import { IconPropsType } from '..';

export const FilledStarIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.00001 10.5534L10.8934 12.9033L9.86021 8.47439L13.3 5.49449L8.77031 5.11019L7.00001 0.933289L5.23601 5.11019L0.700012 5.49449L4.13981 8.47439L3.10661 12.9033L7.00001 10.5534Z"
      fill="currentColor"
    />
  </svg>
);
